import React, { useState, useEffect } from 'react';
import { FaTelegram, FaDiscord, FaCoins } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import api from '../utils/api';
import './SocialIcons.css';

const SocialIcons = ({ variant = 'default' }) => {
  const [socialLinks, setSocialLinks] = useState({
    telegram: '',
    x: '',
    discord: '',
    binance: ''
  });

  useEffect(() => {
    fetchSocialLinks();
  }, []);

  const fetchSocialLinks = async () => {
    const defaults = {
      telegram: '',
      x: '',
      discord: '',
      binance: ''
    };
    try {
      const response = await api.get('/site-settings/social-links');
      const links = response.data.links || {};
      setSocialLinks({
        telegram: links.telegram || defaults.telegram,
        x: links.x || defaults.x,
        discord: links.discord || defaults.discord,
        binance: links.binance || defaults.binance
      });
    } catch (error) {
      // Use default links if API fails (for development)
      console.log('Using default social links');
      setSocialLinks({
        telegram: 'https://t.me/PhoneStreamClub',
        x: 'https://x.com/PhoneStreamClub',
        discord: 'https://discord.gg/uqk9yysW8B',
        binance: 'https://binance.com'
      });
    }
  };

  const iconClass = variant === 'navbar' ? 'social-icon-navbar' : 'social-icon';

  return (
    <div className={`social-icons-container ${variant}`}>
      <a
        href={socialLinks.telegram || 'https://t.me/PhoneStreamClub'}
        target="_blank"
        rel="noopener noreferrer"
        className={iconClass}
        aria-label="Telegram"
        title="Telegram"
      >
        <FaTelegram />
      </a>
      <a
        href={socialLinks.x || 'https://x.com/PhoneStreamClub'}
        target="_blank"
        rel="noopener noreferrer"
        className={iconClass}
        aria-label="X (formerly Twitter)"
        title="X (formerly Twitter)"
      >
        <FaXTwitter />
      </a>
      <a
        href={socialLinks.discord || 'https://discord.gg/uqk9yysW8B'}
        target="_blank"
        rel="noopener noreferrer"
        className={iconClass}
        aria-label="Discord"
        title="Discord"
      >
        <FaDiscord />
      </a>
      <a
        href={socialLinks.binance || 'https://binance.com'}
        target="_blank"
        rel="noopener noreferrer"
        className={iconClass}
        aria-label="Binance"
        title="Binance"
      >
        <FaCoins />
      </a>
    </div>
  );
};

export default SocialIcons;
